import { render, staticRenderFns } from "./GroupNews.vue?vue&type=template&id=471c2193&scoped=true"
import script from "./GroupNews.vue?vue&type=script&lang=js"
export * from "./GroupNews.vue?vue&type=script&lang=js"
import style0 from "./GroupNews.vue?vue&type=style&index=0&id=471c2193&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471c2193",
  null
  
)

export default component.exports